// extracted by mini-css-extract-plugin
export default {"title":"CarouselContainer_title__Hd2u2","carousel":"CarouselContainer_carousel__KDyvV","showAll":"CarouselContainer_showAll__tSyeu"};